import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CartNavComponent } from './cart-nav.component';
import { RouterModule } from '@angular/router';
import { HasClaimModule } from 'src/app/directives/has-claim/has-claim.module';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  imports: [
    CommonModule,
    HasClaimModule,
    MatButtonModule,
    MatTooltipModule,
    RouterModule
  ],
  declarations: [CartNavComponent],
  exports: [CartNavComponent]
})
export class CartNavModule { }
